import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import logo from '../../assets/images/logo/logo.svg';

function Footer(props) {
  const [dataBlock] = useState({
    heading: 'Stay in the Loop',
    desc: 'Get updates on events, drops, and exclusive NXTLVL moments.',
  });

  const [isVisible, setIsVisible] = useState(false);

  // Subscribe states
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);
  const [honeypot, setHoneypot] = useState('');

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const toggleVisibility = () => setIsVisible(window.pageYOffset > 500);
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const clip = (s, n = 1024) => (s && s.length > n ? s.slice(0, n - 3) + '…' : s);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setStatus('');

    // Honeypot
    if (honeypot) {
      setEmail('');
      setStatus('Thanks for subscribing!');
      return;
    }

    // Basic validation
    const trimmed = email.trim();
    if (!trimmed || !emailRegex.test(trimmed)) {
      setStatus('Enter a valid email.');
      return;
    }

    const webhookUrl = process.env.REACT_APP_DISCORD_WEBHOOK_URL;
    if (!webhookUrl) {
      setStatus('Missing webhook env var.');
      return;
    }

    // Build Discord embed
    const embedColor = 0xe11d48;
    const payload = {
      username: 'NXTLVL Website',
      allowed_mentions: { parse: [] },
      embeds: [
        {
          title: '📧 New NXTLVL Subscriber',
          color: embedColor,
          fields: [{ name: 'Email', value: clip(trimmed) }],
          footer: { text: 'nxtlvlnights.com' },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      setSending(true);
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setStatus('Thanks for subscribing!');
        setEmail('');
        setTimeout(() => setStatus(''), 4000);
      } else {
        const txt = await res.text();
        setStatus(txt || 'Error, try again later.');
      }
    } catch (err) {
      setStatus('Error connecting.');
    } finally {
      setSending(false);
    }
  };

  return (
    <footer className="footer">
      <div className="shape"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="footer__main">
              <div className="block-text center">
                <h3 className="heading">{dataBlock.heading}</h3>
                <p>{dataBlock.desc}</p>
              </div>

              {/* Subscribe form posts directly to Discord */}
              <form onSubmit={handleSubscribe} className="form" noValidate>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    aria-label="Email address"
                  />
                  {/* Honeypot (hidden) */}
                  <input
                    type="text"
                    name="company"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                    style={{ display: 'none' }}
                    tabIndex={-1}
                    autoComplete="off"
                  />
                </div>
                <button className="action-btn" disabled={sending}>
                  <span>{sending ? 'Subscribing…' : 'Subscribe'}</span>
                </button>
                {status && <p style={{ marginTop: 8 }}>{status}</p>}
              </form>
            </div>

            <div className="footer__bottom">
              <Link to="/" className="logo">
                <img src={logo} alt="NXTLVL" />
              </Link>

              <div className="center mb--30">
                <ul className="list">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/events">Explore</Link>
                  </li>
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li>
                    <Link to="/events">Events</Link>
                  </li>
                  <li>
                    <Link to="/team">Team</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
                <p>
                  © {new Date().getFullYear()} NXTLVL. All rights reserved. Designed with energy
                  and built for the night.
                </p>
              </div>

              <ul className="list-social">{/* Social links remain unchanged */}</ul>
            </div>
          </div>
        </div>
      </div>

      {isVisible && (
        <Link to="#" onClick={scrollToTop} id="scroll-top">
          <span className="icon-arrow-top"></span>
        </Link>
      )}
    </footer>
  );
}

export default Footer;
